<template>
  <a-cascader
    :field-names="{ label: 'name', value: 'id', children: 'children' }"
    :options="options"
    :load-data="loadData"
    :placeholder="showdata"
    change-on-select
    @change="onChange"
  />
</template>

<script>
import { getRegoin } from "@/api/publish";

export default {
  props: {
    defaultValue: {
      // 按照省，市，區的順序傳
      type: Array,
    },
  },

  data() {
    return {
      selectedProvince: "",
      selectedCity: "",
      selectedDetail: "",
      showdata: this.$t('edit.editMessage.selectDefault'),
      finaldata: {}, // 只獲取最後的那個區域
      options: [],
    };
  },
  watch: {
    defaultValue: {
      handler: function () {
        this.handleDefault();
      },
      immediate: true,
    },
  },
  mounted() {
    getRegoin({ regoin_id: 0 }).then((res) => {
      this.options = this.handleFirstLevel(res.data);
    });
  },
  methods: {
    handleDefault() {
      if (this.defaultValue && this.defaultValue.length > 0) {
        // 設置默認值
        let data = [];
        for (let i = 0; i < this.defaultValue.length; i++) {
          const item = this.defaultValue[i];
          data.push(item.name);
        }
        this.showdata = data.join('/');
      }
    },
    handleFirstLevel(dataList, isLeaf = false) {
      let list = [];
      for (let i = 0; i < dataList.length; i++) {
        let item = dataList[i];
        item.isLeaf = isLeaf;
        list.push(item);
      }
      return list;
    },
    onChange(value) {
      console.log("region=", value);
      this.$emit("regionData", value[value.length - 1]);
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      // load options lazily
      console.log("targetOption=",targetOption)
      getRegoin({ regoin_id: targetOption.id }).then((res) => {
        setTimeout(() => {
          targetOption.loading = false;
          let data = res.data;
          if (data.length > 0) {
            // 判斷是否為最後一級
            data = this.handleFirstLevel(data);
          } else {
            targetOption.isLeaf = true
            this.options = [...this.options];
            return;
          }
          targetOption.children = data;
          this.options = [...this.options];
        }, 50);
      });
    },
  },
};
</script>

<style scoped>
.ant-cascader-picker {
  width: 100%;
}
</style>